import getDefaultDisposalType from 'mini-mail-reading-pane-store/lib/utils/getDefaultDisposalType';
import { getIsPinned } from 'mini-mail-list-store/lib/selectors/mailListDataPropertyGetter';
import { getIsUnflagged, getIsUnread } from 'mini-mail-list-store/lib/utils/getTriageState';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import type { MailListItemViewProps } from '../../components/TouchBehavior';
import {
    lazyApplyItemFlaggedState,
    lazyDeleteItemFromReadingPane as lazyDeleteItem,
    lazyMarkItemsAsRead,
    lazyPinItems,
    lazyArchiveRow,
} from 'mini-mail-triage-actions';

export const deleteItemAction = (props: MailListItemViewProps) => {
    const { rowId } = props.mailListItemDataProps;
    lazyDeleteItem({
        itemId: rowId,
        disposalType: getDefaultDisposalType(rowId),
        source: 'ListView',
    });
};

export const archiveItemAction = (props: MailListItemViewProps) => {
    const { rowId } = props.mailListItemDataProps;
    lazyArchiveRow(rowId, props.tableViewId);
};

export const toggleItemReadAction = (props: MailListItemViewProps) => {
    const { rowId } = props.mailListItemDataProps;
    const tableViewId = props.tableViewId;
    lazyMarkItemsAsRead({
        itemIds: [rowId],
        source: 'ListView',
        shouldMarkAsRead: getIsUnread(rowId),
        tableViewId,
    });
};

export const toggleItemFlagAction = (props: MailListItemViewProps) => {
    const { rowId } = props.mailListItemDataProps;
    lazyApplyItemFlaggedState(rowId, getIsUnflagged(rowId) /* shouldMarkAsFlagged */);
};

export const toggleItemPinAction = (props: MailListItemViewProps) => {
    const { rowId } = props.mailListItemDataProps;
    const tableViewId = props.tableViewId;
    const tableView = getListViewStore().tableViews.get(tableViewId);

    lazyPinItems([rowId], tableViewId, !getIsPinned(rowId, tableView) /* shouldMarkAsPinned */);
};
